import { useModalGallery, } from '@hooks/useModalGallery';
import noop from 'lodash/noop';
import * as React from 'react';
const ModalGalleryContext = React.createContext({
    activeIndex: 0,
    goToIndex: noop,
    goToNext: noop,
    goToPrev: noop,
    maxIndex: 0,
});
export const useModalGalleryContext = () => React.useContext(ModalGalleryContext);
const ModalGalleryProvider = ({ children, ...otherProps }) => {
    const modalGallery = useModalGallery(otherProps);
    return (React.createElement(ModalGalleryContext.Provider, { value: modalGallery }, children));
};
export default ModalGalleryProvider;
